import styled from 'styled-components';

export const Container = styled.div`
    display: grid;
    justify-content: center;
    text-align: center;
    max-width: 100%;
    height: 350px;
    margin-bottom: 30px;
`;

export const Juntar = styled.div`
    max-height: 260px;
`;

export const Body = styled.div`
    max-height: 200px;
    min-height: 200px;
    background-image: url(${(picture) => `/api/storage/app/public/${picture.picture}`});
    background-repeat: no-repeat;
    background-color: #FFFFFF;
    background-position: center;
    Background-size: contain;
    position: relative;
    border-radius: 15px;
`;
    
export const Title = styled.text`
    color: #004070;
    font-size: ${({ tamanho }) => { if (tamanho > '80') { return '15px'; } else { return '20px'; }}};
    font-weight: bold;
    margin-bottom: 30px;
`;

export const Text = styled.text`
    color: #707070;
    font-size: 15px;
`;

export const RedeSocial = styled.div`
    display: flex;
    margin-bottom: 17px;
    max-width: 90%;
    min-width: 300px;
    margin-left: 5%;
    justify-content: space-around;
`;